/* eslint-disable */

/** Reasons for a money movement (a push or pull). */
export enum MovementReason {
  /** PAYMENT_PULL - A pull from a sender of a payment. */
  PAYMENT_PULL = "PAYMENT_PULL",
  /** PAYMENT_PUSH - A push to a recipient of a payment. */
  PAYMENT_PUSH = "PAYMENT_PUSH",
  /** PAYMENT_REFUND_PULL - A pull that refunds a push of a payment. */
  PAYMENT_REFUND_PULL = "PAYMENT_REFUND_PULL",
  /** PAYMENT_REFUND_PUSH - A push that refunds a pull of a payment. */
  PAYMENT_REFUND_PUSH = "PAYMENT_REFUND_PUSH",
  /** PAYMENT_RECLAIM_PULL - A pull that reclaims a failed pull of a payment. */
  PAYMENT_RECLAIM_PULL = "PAYMENT_RECLAIM_PULL",
  /** TRANSFER_PULL - A pull for a transfer between customer instruments. */
  TRANSFER_PULL = "TRANSFER_PULL",
  /** TRANSFER_PUSH - A push for a transfer between customer instruments. */
  TRANSFER_PUSH = "TRANSFER_PUSH",
  /** TRANSFER_REFUND_PULL - A pull that refunds a push of a transfer. */
  TRANSFER_REFUND_PULL = "TRANSFER_REFUND_PULL",
}
